import React, { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { useFeatureFlagContext } from '../../../contexts/FeatureFlagContext'
import { FEATURE_FLAG_KEYS_ENUM } from '../../../models/feature_flags.types'

interface AdminGuardProps {
  children: React.ReactNode
}

const AdminGuard: FC<AdminGuardProps> = ({ children }) => {
  const { featureFlags } = useFeatureFlagContext()
  const isDeveloper = featureFlags[FEATURE_FLAG_KEYS_ENUM.IsDeveloper]

  if (!isDeveloper) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default AdminGuard
